import React, { CSSProperties } from 'react'
import { UserComponent, useNode } from '@craftjs/core'

import {
  spacing,
} from './utils'

const styles: Record<string, CSSProperties> = {
  root: {
    padding: spacing(2),
    height: '100%',
  },
}

interface RootProps {}

const Root: UserComponent<React.PropsWithChildren<RootProps>> = ({
  children,
}) => {
  const { connectors: {connect} } = useNode()

  return (
    <div
      style={ styles.root }
      ref={ connect }
    >
      { children }
    </div>
  )
}

Root.craft = {
  displayName: 'layout',
  rules: {
    canDrag: (node) => false,
    canDrop: (target, node) => true,//node.data.type == Row,
    canMoveIn: (incomingNode) => true,//incomingNode.data.type == Row,
  },
}

export default Root